import type { EntryPointComponent } from 'react-relay';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { jsmChangeManagementSettingsGitLabGatingResource } from '@jira/router-resources__jsm-change-management-settings/src/useGitLabGatingResource.tsx';
import { getServiceDeskSettingsResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { serviceDeskContextResource } from '@jira/router-resources__service-desk-context/src/serviceDeskContextResource.tsx';
import { featuresResource } from '@jira/router-resources__service-project-features/src/featuresResource.tsx';
import { projectSettingsServicedeskChangeManagementRoute } from '@jira/router-routes__project-settings-product-routes-service-desk-routes/src/projectSettingsServicedeskChangeManagementRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { changeManagementSettingsProjectConfigurationResource } from '@jira/router-resources__jsm-change-management-settings/src/changeManagementSettingsProjectConfigurationResource.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';
import ServiceDeskChangeManagementSettings, {
	LazyProjectSettingsServiceDeskChangeManagement,
} from './ui/service-desk-change-management/index.tsx';

const projectSettingsServicedeskChangeManagementPageEntryPoint = createPageEntryPoint({
	main: {
		root: JSResourceForUserVisible<EntryPointComponent<{}, {}, {}, {}>>(
			/* webpackChunkName: "async-project-settings-service-desk-change-management", jiraSpaEntry: "async-project-settings-service-desk-change-management" */ '@jira/spa-apps__project-settings-service-desk-change-management-settings/src/ServiceDeskChangeManagementSettingsPage.tsx',
			{ entryFsSsrLiftImportToModule: false },
		),
		getPreloadProps: () => ({}),
	},
});

export const projectSettingsServicedeskChangeManagementRouteEntry: Route = createEntry(
	projectSettingsServicedeskChangeManagementRoute,
	() => ({
		group: 'project-settings-servicedesk',
		ufoName: 'service-management.change-management-settings',

		// eslint-disable-next-line no-restricted-syntax
		component: fg('nike_entrypoint_migration_batch_2')
			? undefined
			: ServiceDeskChangeManagementSettings,

		entryPoint: () =>
			fg('nike_entrypoint_migration_batch_2')
				? projectSettingsServicedeskChangeManagementPageEntryPoint
				: undefined,
		layout: serviceProjectLayout,

		navigation: {
			menuId: MenuIdProjects,
			sidebarId: SidebarIdProjectSettings,
		},

		resources: [
			...getServiceDeskSettingsResources(),
			serviceDeskContextResource,
			changeManagementSettingsProjectConfigurationResource,
			jsmChangeManagementSettingsGitLabGatingResource,
			featuresResource,
			getConsolidationStateResource(),
		],

		forPaint: [LazyAtlassianNavigation, LazyProjectSettingsServiceDeskChangeManagement],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
